var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.98438H23.5C26.125 5.98438 28.4375 4.54688 29.625 2.29688C29.875 1.92188 30.5 1.92188 30.625 2.29688C31.5 4.60938 32 7.10938 32 9.79688C32 19.8594 25.3125 27.9844 17.0625 27.9844H17C11.875 27.9844 7.5625 24.5469 6.3125 19.7969C4.25 21.7344 3 24.4844 3 27.4844V28.4844C3 29.3594 2.3125 29.9844 1.5 29.9844C0.625 29.9844 0 29.3594 0 28.4844V27.4844C0 22.7969 2.375 18.6719 6 16.2969C7.3125 15.3594 8.8125 14.7344 10.4375 14.3594C11.4375 14.1094 12.4375 13.9844 13.5 13.9844H18H19C19.5 13.9844 20 13.5469 20 12.9844C20 12.4844 19.5 11.9844 19 11.9844H13.5C10.9375 11.9844 8.5625 12.6094 6.5 13.6719C7.875 9.23438 12.0625 5.98438 17 5.98438Z",
    fill: "#A63F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.61a8f67deb1ce430f8875c5eaabbce22.svg";
export { ForwardRef as ReactComponent };